import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest not authed, obj=user
  const [token, setToken] = useState(() => localStorage.getItem("nw_token") || null);

  const loadMe = useCallback(async () => {
    const t = localStorage.getItem("nw_token");
    if (!t) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("nw_token");
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  // Heartbeat: ping /auth/me every 60s while the tab is open + when it regains focus.
  // This keeps the session's last_beat_at fresh so session-duration analytics work.
  useEffect(() => {
    if (!token) return;
    const beat = () => {
      if (document.visibilityState !== "visible") return;
      api.get("/auth/me").catch(() => {});
    };
    const id = setInterval(beat, 60_000);
    const onVis = () => { if (document.visibilityState === "visible") beat(); };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", beat);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("focus", beat);
    };
  }, [token]);

  const setSession = (t, u) => {
    localStorage.setItem("nw_token", t);
    setToken(t);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("nw_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, token, setSession, logout, refresh: loadMe, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
